import {
  convertDOBToAge,
  CURR_YEAR_END_DATE,
  getDaysDiff,
  getMonthDiff
} from '../../flows/shared/dateUtils';

export const getCustomersEndOfYearAge = dob => {
  const age = convertDOBToAge(dob);

  const months = getMonthDiff(CURR_YEAR_END_DATE, dob);
  const days = getDaysDiff(CURR_YEAR_END_DATE, dob);

  return `*Participants age will be ${age} years ${months} month(s) ${days} day(s) by year end.`;
};
